import EnlargeCollapse from './EnlargeCollapse.tsx';
import Flash from './Flash.tsx';
import Lock from './Lock.tsx';
import Menu from './Menu.tsx';
import More from './More.tsx';
import ToggleLeftSection from './ToggleLeftSection.tsx';
import ToggleList from './ToggleList.tsx';
import ToggleRightSection from './ToggleRightSection.tsx';

export const DefaultIcons = {
  EnlargeCollapse,
  Flash,
  Lock,
  Menu,
  More,
  ToggleLeftSection,
  ToggleList,
  ToggleRightSection,
};

export default DefaultIcons;
